"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 14 14';

var Note = function Note() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "m10.818 0h-7.636a3.182 3.182 0 0 0-3.182 3.182v7.636a3.182 3.182 0 0 0 3.182 3.182h7.636a3.182 3.182 0 0 0 3.182-3.182v-7.636a3.182 3.182 0 0 0-3.182-3.182zm-7.636 1.273h7.636a1.91 1.91 0 0 1 1.91 1.909v7.636a1.91 1.91 0 0 1-1.91 1.91h-7.636a1.91 1.91 0 0 1-1.91-1.91v-7.636a1.91 1.91 0 0 1 1.91-1.91z"
  }), _react["default"].createElement("path", {
    d: "m9.513 9.355c0.37 0 0.669-0.356 0.669-0.796s-0.3-0.795-0.67-0.795h-6.296c-0.37 0-0.67 0.356-0.67 0.795 0 0.44 0.3 0.796 0.67 0.796z"
  }), _react["default"].createElement("path", {
    d: "m10.674 6.173c0.431 0 0.78-0.357 0.78-0.795 0-0.44-0.349-0.796-0.78-0.796h-7.348c-0.43521 0.0044-0.78444 0.36079-0.78 0.796 0 0.438 0.349 0.795 0.78 0.795z"
  }));
};

var _default = (0, _createSvgIcon["default"])(Note, {
  viewBox: viewBox
});

exports["default"] = _default;